import React, { FunctionComponent, ReactNode } from 'react'
import styles from './ProjectList.module.sass'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'
import clsx from 'clsx'
import { Classes } from '../../../../styles'

export const DoubleCell: FunctionComponent<{ top: ReactNode, bottom: ReactNode }> = props => {
    return <div className={styles.doubleCell}>
        <Ellipsis className={clsx(styles.top, Classes.f13b)}>{props.top}</Ellipsis>
        <Ellipsis className={clsx(styles.bottom, Classes.f11)}>{props.bottom}</Ellipsis>
    </div>
}